import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../interfaces/app-state.interface';
import { LoginChallengeResultType } from '../models/authentication/login.challenge.result.types';
import { LoginWraperService } from '../services/login.wraper.service';
import { SettingsService } from '../services/settings/settings.service';
import { UsersState } from '../state-management/users/users.reducer';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

    private usersState: UsersState;
    private authentication$: Observable<UsersState>;

    constructor(
        private router: Router,
        private store: Store<AppState>,
        private loginWraperService: LoginWraperService,
        private settingsService: SettingsService,
        ) {

        this.authentication$ = this.store.select((state) => state.authentication);
        this.authentication$.subscribe((authState) => this.usersState = authState);
    }

    // Método de Interface
    public canActivate() {

        if (this.usersState.currentUser &&
            this.usersState.currentUser.token &&
            this.settingsService.isOnLoggedDomain()) {
                return true;
            }

        this.loginWraperService.navigateToLogin();
        // this.requestLogin(this.location.path());
        return false;

    }

    public canLoad(route: Route) {
        if (this.usersState.currentUser) {
            return true;
        }

        this.loginWraperService.navigateToLogin();
        // this.requestLogin(this.location.path());
        return false;
    }

    private async requestLogin(route: string) {
        await this.loginWraperService
            .requestUserLogin()
            .toPromise()
            .then((result) => {
                if (result.result === LoginChallengeResultType.Success) {

                    this.router.navigate([route.length ? route : './']);
                    return true;

                } else {
                    this.router.navigate(['./']);
                    return false;
                }
        });
    }

}
